// src/components/UploadStudyMode.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '../common/Button'; // Assuming new Button component path
import { IoIosFlash } from 'react-icons/io';

export const UploadStudyMode = () => {
  const { t } = useTranslation('Actions');
  const navigate = useNavigate();

  const handleRealtimeClick = () => {
    navigate('/realtimeexam');
  };

  return (
    <div className="relative">
      <Button onClick={handleRealtimeClick} size="sm" className="text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2 whitespace-nowrap">
        <IoIosFlash className="mr-1 h-3 w-3 sm:h-4 sm:w-4"/>
        <span className="hidden sm:inline">{t('realtime')}</span>
        <span className="sm:hidden">{t('realtimeShort')}</span>
      </Button>
    </div>
  );
};